import { render, staticRenderFns } from "./MetaDataForm.vue?vue&type=template&id=9c67fd86"
import script from "./MetaDataForm.vue?vue&type=script&lang=js"
export * from "./MetaDataForm.vue?vue&type=script&lang=js"
import style0 from "./MetaDataForm.vue?vue&type=style&index=0&id=9c67fd86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports